import type { WorldThemeId } from '@duck/contracts';

/**
 * The room LEVEL a player can create or register into (ADR-0054 dual-level). Only the two real levels are
 * offered — every other {@link WorldThemeId} is a cosmetic skin that renders the office level, so it never
 * appears in a room-type picker. The castle is first and the default. ONE source of truth, shared by the
 * register form and the lobby's create-room dialog so the two pickers can never drift apart (ADR-0055).
 */
export type RoomLevelId = Extract<WorldThemeId, 'medieval_castle' | 'medieval_office' | 'office'>;

export const ROOM_TYPES: { id: RoomLevelId; icon: string; label: string; blurb: string }[] = [
  { id: 'medieval_castle', icon: '🏰', label: 'Grand Castle', blurb: 'The sprawling 27-room keep — courts, towers, gardens… and fire.' },
  { id: 'medieval_office', icon: '🏯', label: 'Classic Castle', blurb: 'The cosy original — one grand hall, a forge, a tavern, a hearth.' },
  { id: 'office', icon: '🏢', label: 'Office', blurb: 'The classic cozy workspace floor.' },
];
